// generated from 25_934 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const lastReceivedSpecificWorkflowStepFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("last_received_specific_workflow_step_filter"),
  comparison_key: z.enum([
    "4", // 15_143 (58.39%)
    "6", // 9_456 (36.46%)
    "3", // 968 (3.73%)
    "5", // 367 (1.42%)
  ]),
  display_name: z.object({
    id: common.objectId,
    // undefined: 2 (0.01%), defined 25_932 (99.99%)
    pre_filter_shell_value: z
      .object({
        // true 4_769 (18.39%), false 21_163 (81.61%)
        expired: z.boolean(),
        id: common.objectId,
        value: z.string(),
      })
      .optional(),
    value: z.string(),
  }),
  // undefined: 25_932 (99.99%), defined 2 (0.01%)
  has_hard_deleted_data: z.literal(true).optional(),
  // undefined: 12_976 (50.03%), defined 12_958 (49.97%)
  raw_value: z
    .union([
      // number samples: 11_943 (92.17%)
      // integer: 6_667 (55.82%)
      // avg: 14.34, min: 0, max: 999
      z.number().min(0),
      // string samples: 1_015 (7.83%)
      // format date: 770 (75.86%)
      z.string(),
    ])
    .optional(),
  value: z.union([
    // number samples: 24_300 (93.70%)
    // integer: 14_504 (59.69%)
    // avg: 12.35, min: 0, max: 999
    z.number().min(0),
    // string samples: 1_634 (6.30%)
    // format date: 1_329 (81.33%)
    z.string(),
  ]),
  varies_by_app_group: z.literal(true),
});
